import React, { useState } from 'react';
import { AssigneeType } from '@enums/assignee-type.enum';
import { Brushaway, BrushawayBody, BrushawayFooter, BrushawayHeader, Button, InlineNotification } from '@ui';
import { draftDurationMinutes, validateDraft, draftToValues } from './draft';
import VisitFormFields from './VisitFormFields';
import VisitExtraFields from './VisitExtraFields';
import { useAvailabilityWarning } from './useAvailabilityWarning';
import { parseDate, parseTime } from './formatters';
import { t, tGeneric } from './translate';
function VisitBrushaway({ initialDraft, visitId, isEditing, defaults, subcontractorsEnabled, technicianOptions, subcontractorOptions, timeZoneOptions, checkAvailabilityUrl, series, saving, serverError, onSubmit, onClose }) {
    var _a;
    const [draft, setDraft] = useState(initialDraft);
    const [errors, setErrors] = useState({});
    const update = (patch) => setDraft((prev) => (Object.assign(Object.assign({}, prev), patch)));
    const checkable = draft.assigneeType === AssigneeType.TECHNICIAN &&
        draft.technicianId !== null &&
        parseDate(draft.scheduledDate) !== null &&
        parseTime(draft.scheduledTime) !== null;
    const conflict = useAvailabilityWarning(checkAvailabilityUrl, checkable
        ? {
            technicianId: draft.technicianId,
            scheduledDate: draft.scheduledDate,
            scheduledTime: draft.scheduledTime,
            duration: draftDurationMinutes(draft),
            timeZone: draft.timeZone,
            visitId
        }
        : null);
    const handleSubmit = () => {
        const found = validateDraft(draft);
        setErrors(found);
        if (Object.keys(found).length === 0)
            onSubmit(draftToValues(draft));
    };
    return (React.createElement(Brushaway, { controlledOpen: true, onClose: onClose, className: "visits-section__brushaway" },
        React.createElement(BrushawayHeader, { title: isEditing ? t('edit_title') : t('add_title'), closeLabel: tGeneric('close') }),
        React.createElement(BrushawayBody, null,
            React.createElement("div", { className: "visits-section__form" },
                serverError && React.createElement(InlineNotification, { variant: "error" }, serverError),
                React.createElement(VisitFormFields, { draft: draft, errors: errors, defaults: defaults, subcontractorsEnabled: subcontractorsEnabled, technicianOptions: technicianOptions, subcontractorOptions: subcontractorOptions, timeZoneOptions: timeZoneOptions, disabled: saving, onChange: update }),
                React.createElement(VisitExtraFields, { draft: draft, disabled: saving, showSeries: visitId === undefined && series !== null, seriesFrequencyLabel: (_a = series === null || series === void 0 ? void 0 : series.frequencyLabel) !== null && _a !== void 0 ? _a : null, conflict: conflict, onChange: update }))),
        React.createElement(BrushawayFooter, null,
            React.createElement(Button, { onClick: onClose, disabled: saving }, tGeneric('cancel')),
            React.createElement(Button, { variant: "primary", onClick: handleSubmit, disabled: saving }, isEditing ? t('submit_save') : t('submit_add')))));
}
export default VisitBrushaway;
